function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as fudouActiveApi from '@/api/fudouActiveApi.js';
import * as categoryApi from '@/api/categoryApi.js';
import * as storeApi from '@/api/store';
export default {
  components: {},
  data: function data() {
    return {
      visible: false,
      pram: {},
      editIdx: 0,
      tagOption: [],
      jdCateIdsOption: [],
      // 京东商品分类
      cateIdsOption: [],
      // 商品分类
      GOODS_TYPE_MAP: [{
        name: '自营商品',
        key: 1
      }, {
        name: '福司令商品',
        key: 2
      }, {
        name: '自营+福司令',
        key: 3
      }, {
        name: '蛋糕商品',
        key: 4
      }]
    };
  },
  mounted: function mounted() {},
  methods: {
    openInit: function openInit(editIdx) {
      var row = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.getCate();
      this.searchTag();
      this.pram = _objectSpread({}, row);
      this.editIdx = editIdx;
      this.visible = true;
    },
    saveEdit: function saveEdit() {
      this.$emit('saveEdit', this.editIdx, this.pram);
      this.visible = false;
    },
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    changeSourceType: function changeSourceType() {
      var _ref = this.pram || {},
        sourceType = _ref.sourceType,
        type = _ref.type,
        id = _ref.id;
      this.pram = {
        sourceType: sourceType,
        type: type,
        id: id
      };
      if (sourceType == 2 && type == 2) {
        var _this$pram;
        (_this$pram = this.pram) === null || _this$pram === void 0 ? true : delete _this$pram.type;
      }
      ;
    },
    getCate: function getCate() {
      var _this = this;
      this.jdCateIdsOption = [];
      categoryApi.jdCateLists().then(function (res) {
        _this.jdCateIdsOption = res;
      });
      this.cateIdsOption = [];
      storeApi.categoryApi({
        status: -1,
        type: 1
      }).then(function (res) {
        _this.cateIdsOption = _this.addDisabled(res);
      });
    },
    searchTag: function searchTag() {
      var _this2 = this;
      this.tagOption = [];
      storeApi.getLabelApi().then(function (res) {
        _this2.tagOption = res || [];
      });
    },
    addDisabled: function addDisabled() {
      var _this3 = this;
      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var list = [];
      arr && arr.length && arr.forEach(function (e, index) {
        var e_new = _objectSpread(_objectSpread({}, e), {}, {
          disabled: !e.status
        });
        if (e.child) {
          var childList = _this3.addDisabled(e.child);
          e_new = _objectSpread(_objectSpread({}, e_new), {}, {
            child: childList
          });
        }
        list.push(e_new);
      });
      return list;
    }
  }
};